module.exports = __webpack_public_path__ + "img/typless_banner.b29292b.svg";